<template>
  <div>
    <b-modal
      id="ModalPhase2"
      title="ปริมาณจราจรแต่ละ Phase (PCU รายชั่วโมง)"
      size="xl"
      ok-only
      ok-title="ปิด"
    >
      <b-row>
        <b-col lg="12">
          <template>
            <b-row>
              <!-- <b-col
                lg="5"
                md="6"
              >
                <span style="font-size:20px; color: #fff;">ปริมาณจราจรแต่ละ Phase (PCU รายชั่วโมง)</span>
              </b-col> -->
              <b-col
                class="d-flex align-items-center justify-content-end"
                lg="12"
                md="6"
              >
                <label style="padding-right:14px; font-size: 15px">วันที่</label>
                <b-form-group style="padding-right:14px">
                  <flat-pickr
                    v-model="date.dateFrom"
                    class="form-control"
                    @input="graphBar"
                  />
                </b-form-group>
                <!-- <label style="padding-right:14px; font-size: 15px">ถึง</label>
                  <b-form-group>
                    <flat-pickr
                      v-model="date.dateTo"
                      class="form-control"
                      @input="getHistory"
                    />
                  </b-form-group> -->

                <!-------------------------------- รายงาน ----------------------------->
                <div class="mb-1 ml-1">
                  <b-dropdown
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    text="รายงาน"
                    split
                    variant="primary"
                    right
                  >
                    <b-dropdown-item
                      target="_blank"
                      :href="'https://drr-report.enixma.net/Report_Quantity_Speed_Hour.aspx?pid=' + this.$route.query.wid"
                    >
                      สรุปปริมาณรถรายชั่วโมง
                    </b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-item
                      target="_blank"
                      :href="'https://drr-report.enixma.net/Report_Quantity_Speed_Day.aspx?pid=' + this.$route.query.wid"
                    >
                      สรุปปริมาณรถรายวัน
                    </b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-item
                      target="_blank"
                      :href="'https://drr-report.enixma.net/Report_Quantity_Speed_Month.aspx?pid=' + this.$route.query.wid"
                    >
                      สรุปปริมาณรถรายเดือน
                    </b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-item
                      target="_blank"
                      :href="'https://drr-report.enixma.net/Report_QuantityPCU_Speed_AVG_Day.aspx?pid=' + this.$route.query.wid"
                    >
                      สรุปปริมาณรถ (PCU) รายวัน
                    </b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-item
                      target="_blank"
                      :href="'https://drr-report.enixma.net/Report_QuantityPCU_Speed_AVG_Month.aspx?pid=' + this.$route.query.wid"
                    >
                      สรุปปริมาณรถ (PCU) รายเดือน
                    </b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-item
                      target="_blank"
                      :href="'https://drr-report.enixma.net/Report_Graph_Quantity_Speed_Day.aspx?pid=' + this.$route.query.wid"
                    >
                      สรุปปริมาณรถกราฟรายวัน
                    </b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-item
                      target="_blank"
                      :href="'https://drr-report.enixma.net/Report_Graph_Quantity_Speed_Month.aspx?pid=' + this.$route.query.wid"
                    >
                      สรุปปริมาณรถกราฟรายเดือน
                    </b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-item
                      target="_blank"
                      :href="'https://drr-report.enixma.net/Report_Graph_QuantityPCU_Speed_AVG_Day.aspx?pid=' + this.$route.query.wid"
                    >
                      สรุปปริมาณรถกราฟ (PCU) รายวัน
                    </b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-item
                      target="_blank"
                      :href="'https://drr-report.enixma.net/Report_Graph_QuantityPCU_Speed_AVG_Month.aspx?pid=' + this.$route.query.wid"
                    >
                      สรุปปริมาณรถกราฟ (PCU) รายเดือน
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-col>
            </b-row>
          </template>
        </b-col>
        <b-col>
          <AppEchartBar
            class="mt-1"
            style="width:95%"
            :option-data="option"
          />
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BDropdown, BDropdownItem, BDropdownDivider,
  BModal,
// BCard, BCardText,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
// import * as echarts from 'echarts'
import flatPickr from 'vue-flatpickr-component'
import AppEchartBar from '@/views/traffiscifi/detailfi2/echartBar/AppEchartBar.vue'

export default {
  components: {
    AppEchartBar,
    BRow,
    BCol,
    BFormGroup,
    // BCardCode,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    flatPickr,
    BModal,
    // BCardText,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      date: {
        wid: this.$route.query.wid,
        dateFrom: '',
      },
      option: {
        legend: {
          left: 50,
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          // eslint-disable-next-line consistent-return
          formatter(params) {
            if (params.length > 3) {
              return `${params[0].name} <br />
                ${params[0].seriesName}: ${params[0].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} คัน <br />
                ${params[1].seriesName}: ${params[1].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} คัน <br />
                ${params[2].seriesName}: ${params[2].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} คัน <br />
                ${params[3].seriesName}: ${params[3].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} คัน
                `
            } if (params.length === 3) {
              return `${params[0].name} <br />
                ${params[0].seriesName}: ${params[0].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} คัน <br />
                ${params[1].seriesName}: ${params[1].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} คัน <br />
                ${params[2].seriesName}: ${params[2].value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} คัน
                `
            }
          },
        },
        xAxis: [
          {
            type: 'category',
            splitLine: { show: false },
            data: [],
            axisLabel: {
              color: '#fff',
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false },
            axisLabel: {
              color: '#fff',
            },
          },
        ],
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 10,
          },
          {
            start: 0,
            end: 10,
          },
        ],
        grid: {
          width: '89%',
          height: '80%',
        },
        series: [
          {
            name: 'Phase1',
            type: 'bar',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '10px',
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              color: '#0D4C92',
            },
            label: {
              show: true,
              position: 'top',
              color: '#3C99FF',
              fontSize: '14',
              // formatter: '{c}',
              formatter(d) {
                return d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              },
            },
          },
          {
            name: 'Phase2',
            type: 'bar',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '10px',
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              color: '#59C1BD',
            },
            label: {
              show: true,
              position: 'top',
              color: '#59C1BD',
              fontSize: '14',
              // formatter: '{c}',
              formatter(d) {
                return d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              },
            },
          },
          {
            name: 'Phase3',
            type: 'bar',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '10px',
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              color: '#A0E4CB',
            },
            label: {
              show: true,
              position: 'top',
              color: '#A0E4CB',
              fontSize: '14',
              // formatter: '{c}',
              formatter(d) {
                return d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              },
            },
          },
          {
            name: '',
            type: 'bar',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '10px',
            itemStyle: {
              barBorderRadius: [5, 5, 0, 0],
              color: '#CFF5E7',
            },
            label: {
              show: true,
              position: 'top',
              color: '#CFF5E7',
              fontSize: '14',
              // formatter: '{c}',
              formatter(d) {
                return d.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              },
            },
          },
        ],
      },
      check: '',
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    // this.checkPhase()
    // this.setToday()
    // this.graphBar()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.graphBar()
    }, 300000)
  },
  methods: {
    graphBar() {
      axios.post('/getPieTrafficDetail1', this.date)
        .then(response => {
          this.resetChart()
          this.xAxisData = []
          this.xAxisData = response.data
          if (this.check === 4) {
            this.xAxisData.forEach(value => {
              this.option.xAxis[0].data.push(value.Period_Name)
              this.option.series[0].data.push(value.Phase1_PCU)
              this.option.series[1].data.push(value.Phase2_PCU)
              this.option.series[2].data.push(value.Phase3_PCU)
              this.option.series[3].data.push(value.Phase4_PCU)
              this.option.series[2].itemStyle.barBorderRadius = [5, 5, 0, 0]
              this.option.series[3].itemStyle.barBorderRadius = [5, 5, 0, 0]
              this.option.series[3].name = 'Phase4'
            })
          }
          if (this.check === 3) {
            this.xAxisData.forEach(value => {
              this.option.xAxis[0].data.push(value.Period_Name)
              this.option.series[0].data.push(value.Phase1_PCU)
              this.option.series[1].data.push(value.Phase2_PCU)
              this.option.series[2].data.push(value.Phase3_PCU)
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    checkPhase() {
      axios
        .post('/checkPhaseTraffic', { wid: this.$route.query.wid })
        .then(response => {
          this.check = response.data[0].PhaseNo
        })
        .catch(error => {
          console.log(error)
        })
    },

    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      const date = (`0${p.getDate()}`).slice(-2)
      const year = p.getFullYear()
      this.date.dateFrom = `${year}-${month}-${date}`
      // this.date.dateTo = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    },
    resetChart() {
      this.option.xAxis[0].data.splice(0)
      this.option.series[0].data.splice(0)
      this.option.series[1].data.splice(0)
      this.option.series[2].data.splice(0)
      this.option.series[3].data.splice(0)
    },
  },
}
</script>

<style scoped>
  .pie-text1{
    width: 200px;
    position:absolute;
    margin: auto;
    left: 85%;
    right: 0;
    top: 20%;
    bottom: 0;
  }
</style>
